/**
 * Reviews section for the service detail page. Renders the shared TestimonialsCarousel in
 * reviews-only mode (no interleaved photos) with this service's Strapi reviews. When the
 * service has no reviews, the carousel falls back to its shared generic testimonials.
 */
import React from 'react'
import TestimonialsCarousel from '../about-us/TestimonialsCarousel'

/**
 * @param {{ reviews?: Array<{ stars: number, title: string, quote: string, name: string }> }} props
 */
const ReviewsSection = ({ reviews = [] }) => (
  <TestimonialsCarousel titleAlign="left" showPhotos={false} reviews={reviews.length ? reviews : undefined} />
)

export default ReviewsSection
